var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 3H0.75C0.336 3 0 3.336 0 3.75V20.25C0 20.664 0.336 21 0.75 21H23.25C23.664 21 24 20.664 24 20.25V3.75C24 3.336 23.664 3 23.25 3Z",
    fill: "url(#paint0_linear_1054_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.75C2.808 6.75 2.61637 6.67687 2.46975 6.53025L1.71975 5.78025C1.42687 5.48737 1.42687 5.01263 1.71975 4.71975C2.01262 4.42688 2.48738 4.42688 2.78025 4.71975L3.53025 5.46975C3.82312 5.76263 3.82312 6.23737 3.53025 6.53025C3.38362 6.67687 3.192 6.75 3 6.75ZM22.2803 19.2803C22.5731 18.9874 22.5731 18.5126 22.2803 18.2197L21.5303 17.4697C21.2374 17.1769 20.7626 17.1769 20.4697 17.4697C20.1769 17.7626 20.1769 18.2374 20.4697 18.5303L21.2197 19.2803C21.3664 19.4269 21.558 19.5 21.75 19.5C21.942 19.5 22.1336 19.4269 22.2803 19.2803ZM21.5303 6.53025L22.2803 5.78025C22.5731 5.48737 22.5731 5.01263 22.2803 4.71975C21.9874 4.42688 21.5126 4.42688 21.2197 4.71975L20.4697 5.46975C20.1769 5.76263 20.1769 6.23737 20.4697 6.53025C20.6164 6.67687 20.808 6.75 21 6.75C21.192 6.75 21.3836 6.67687 21.5303 6.53025ZM2.78025 19.2803L3.53025 18.5303C3.82312 18.2374 3.82312 17.7626 3.53025 17.4697C3.23737 17.1769 2.76262 17.1769 2.46975 17.4697L1.71975 18.2197C1.42687 18.5126 1.42687 18.9874 1.71975 19.2803C1.86637 19.4269 2.058 19.5 2.25 19.5C2.442 19.5 2.63363 19.4269 2.78025 19.2803ZM18.75 5.25C18.75 4.836 18.414 4.5 18 4.5H6C5.586 4.5 5.25 4.836 5.25 5.25C5.25 5.664 5.586 6 6 6H18C18.414 6 18.75 5.664 18.75 5.25ZM22.5 15V9C22.5 8.586 22.164 8.25 21.75 8.25C21.336 8.25 21 8.586 21 9V15C21 15.414 21.336 15.75 21.75 15.75C22.164 15.75 22.5 15.414 22.5 15ZM18.75 18.75C18.75 18.336 18.414 18 18 18H6C5.586 18 5.25 18.336 5.25 18.75C5.25 19.164 5.586 19.5 6 19.5H18C18.414 19.5 18.75 19.164 18.75 18.75ZM3 15V9C3 8.586 2.664 8.25 2.25 8.25C1.836 8.25 1.5 8.586 1.5 9V15C1.5 15.414 1.836 15.75 2.25 15.75C2.664 15.75 3 15.414 3 15Z",
    fill: "url(#paint1_linear_1054_16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5C10.3459 7.5 9 8.84588 9 10.5C9 12.1541 10.3459 13.5 12 13.5C13.6541 13.5 15 12.1541 15 10.5C15 8.84588 13.6541 7.5 12 7.5Z",
    fill: "url(#paint2_linear_1054_16)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.25C12.4142 11.25 12.75 10.9142 12.75 10.5C12.75 10.0858 12.4142 9.75 12 9.75C11.5858 9.75 11.25 10.0858 11.25 10.5C11.25 10.9142 11.5858 11.25 12 11.25Z",
    fill: "url(#paint3_linear_1054_16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9219 11.1716C14.665 12.2869 13.7871 13.1651 12.6719 13.4216L15.0002 15.75L15.7502 14.25L17.2502 13.5L14.9219 11.1716Z",
    fill: "url(#paint4_linear_1054_16)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07837 11.1716L6.75 13.5L8.25 14.25L9 15.75L11.3284 13.4216C10.2131 13.1651 9.33525 12.2869 9.07837 11.1716Z",
    fill: "url(#paint5_linear_1054_16)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1054_16",
    x1: 1.71975,
    y1: 22.2806,
    x2: 22.2802,
    y2: 1.71975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1054_16",
    x1: 3.22012,
    y1: 20.7806,
    x2: 20.7806,
    y2: 3.22013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1054_16",
    x1: 9.87975,
    y1: 12.6203,
    x2: 14.1203,
    y2: 8.37975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1054_16",
    x1: 11.4701,
    y1: 11.0302,
    x2: 12.5302,
    y2: 9.97012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1054_16",
    x1: 13.8366,
    y1: 14.5864,
    x2: 16.0866,
    y2: 12.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1054_16",
    x1: 7.875,
    y1: 14.6254,
    x2: 10.2034,
    y2: 12.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievement);
export default __webpack_public_path__ + "static/media/achievement.6211720ed73a64e82d116692fcb831d2.svg";
export { ForwardRef as ReactComponent };